import { useResolvedLayout } from '@/shared/lib/layout';
import { Stage } from '../Stage';
import type { BriefingScreenProps } from './types';

/**
 * Desktop + tablet briefing/lobby shell — cork stage with the dossier
 * top bar, suspect roster on the left, and an aside column (briefing
 * panel or waiting paper) on the right. Tablet uses a denser aside col.
 */
export const DesktopBriefingScreen = ({
  board,
  aside,
  desktopTopBar,
}: Pick<BriefingScreenProps, 'board' | 'aside' | 'desktopTopBar'>) => {
  const layout = useResolvedLayout();
  const isDesktop = layout === 'desktop';
  return (
    <Stage tone="board">
      <main className="relative mx-auto flex h-full w-full max-w-[1280px] flex-col px-6 py-6 lg:px-10">
        {desktopTopBar}
        <div
          className={[
            'mt-4 grid min-h-0 flex-1 gap-6 lg:gap-10',
            isDesktop ? 'grid-cols-[minmax(0,1fr)_460px]' : 'grid-cols-[minmax(0,1fr)_400px]',
          ].join(' ')}
        >
          <div className="min-h-0 min-w-0 overflow-hidden">{board}</div>
          {aside}
        </div>
      </main>
    </Stage>
  );
};
